import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-responses-summary',
  templateUrl: './responses-summary.component.html',
  styleUrls: ['./responses-summary.component.scss']
})
export class ResponsesSummaryComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
